import * as yup from "yup";

export default t => yup.object().shape({
  content: yup.string().trim()
    .required(t("field_is_required"))
    .test("length", self => t("text_too_long_detailed", { is: self.originalValue.length, max: 2000 }), val => val.length <= 2000),
  coachCanSee: yup.boolean().required(t("field_is_required")),
  isPublic: yup.boolean().required(t("field_is_required")),
});
